import { render, staticRenderFns } from "./AmountNumber.vue?vue&type=template&id=1a43df54&scoped=true"
import script from "./AmountNumber.vue?vue&type=script&lang=js"
export * from "./AmountNumber.vue?vue&type=script&lang=js"
import style0 from "./AmountNumber.vue?vue&type=style&index=0&id=1a43df54&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a43df54",
  null
  
)

export default component.exports